var _rect, _rect2, _path, _path2, _path3, _path4, _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRedeemActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -4074,
    y: -3879,
    width: 11584,
    height: 15424,
    fill: "#5D5CF5",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-28 -232H228V668H-28V-232Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-28 -232H228V668H-28V-232Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-28 -14H228V16V46H-28V-14Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-21 -8C-21 -12.4183 -17.4183 -16 -13 -16H210C214.418 -16 218 -12.4183 218 -8V8.37548C218 9.7677 218.363 11.1358 219.054 12.3446L221.716 17.0039C221.892 17.3113 221.892 17.6887 221.716 17.9961L219.054 22.6554C218.363 23.8642 218 25.2323 218 26.6245V40C218 44.4183 214.418 48 210 48H-13C-17.4183 48 -21 44.4183 -21 40V-8Z",
    fill: "#5D5CF5",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5E61EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.52402 23.7384H8.57205C8.86145 23.7384 9.09607 23.5038 9.09607 23.2144V17.4502H7.52402C7.23462 17.4502 7 17.6848 7 17.9742V23.2144C7 23.5037 7.23462 23.7384 7.52402 23.7384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8C15.7908 8 14 9.79083 14 12C14 14.2091 15.7908 16 18 16C20.2092 16 22 14.2091 22 12C22 9.79083 20.2092 8 18 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 3,
    fill: "#5D5CF5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.9992,
    cy: 12.0002,
    r: 2.3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4607 24.018H16.576C18.3367 23.997 20.024 23.4975 21.5123 22.5961L24.4362 20.5525C24.9288 20.2066 25.0231 19.5568 24.6982 19.0957C24.3629 18.6136 23.7131 18.4983 23.2415 18.8337L20.4328 20.804C19.5314 21.328 18.431 21.4433 17.4354 21.1079L14.2039 20.0389C13.9315 19.9551 13.7847 19.6511 13.8791 19.3787C13.9629 19.1167 14.2354 18.9699 14.5078 19.0433C14.5183 19.0433 18.1375 20.2171 18.1375 20.2171C18.747 20.3998 19.2885 20.0549 19.458 19.5464C19.6362 18.9909 19.3323 18.404 18.7873 18.2258L13.8581 16.6119C12.7799 16.2194 11.327 16.3005 10.1445 16.9617V22.828L14.2563 23.7594C15.0095 23.9251 15.7486 24.018 16.4607 24.018Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedeemActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/redeem-active.d7ec447b.svg";
export { ForwardRef as ReactComponent };